import classNames from 'classnames';
import { FC } from 'react';
import Checkbox from '../../../../../../ReactSharedScripts/components/Checkbox';
import { CheckboxProps } from '../../../../../../ReactSharedScripts/components/Checkbox/types';
import classes from './styles/index.module.scss';

type SpreadsheetBodyRowCheckboxProps = Pick<CheckboxProps, 'checked' | 'onChange' | 'disabled'> & {
	className?: string;
	hasTinyVrPadding?: boolean;
	style?: React.CSSProperties;
};

export const SpreadsheetBodyRowCheckboxLayout: FC<SpreadsheetBodyRowCheckboxProps> = ({
	className,
	hasTinyVrPadding,
	checked,
	onChange,
	disabled,
	style,
}) => {
	const componentClasses = classNames(
		classes.bodyRowItemCheckbox,
		{
			[classes.bodyRowItemCheckbox_hasTinyVrPadding]: hasTinyVrPadding,
		},
		className,
	);

	return (
		<div
			className={componentClasses}
			style={style}
		>
			<div>
				<Checkbox
					checked={checked}
					onChange={onChange}
					className={classes.checkbox}
					disabled={disabled}
				/>
			</div>
		</div>
	);
};
